export function getStageLabel(stage) {
  let stageLabel = stage.toUpperCase();

  if (stage === 'rfpq') {
    stageLabel = 'RFP/Q';
  }

  return stageLabel;
}
